/**
 * Centralised TanStack Query keys for ledger tax settings.
 *
 * A settings change moves every calculation that reads a rate, so the mutation
 * invalidates several domains at once. Keeping the keys here is what lets that
 * stay a one-liner instead of a drifting string literal.
 *
 * `all` is the shared prefix, so invalidating it clears the current set, the
 * history and every cached date lookup in one call — a new set can change what
 * any of them would return.
 */
export const SettingsQueryKeys = {
    all: ['ledger-settings'] as const,
    /** The set in force today. */
    current: () => [...SettingsQueryKeys.all, 'current'] as const,
    /** The full change history, newest first. */
    history: () => [...SettingsQueryKeys.all, 'history'] as const,
    /** The set in force on one date. */
    onDate: (date: string) =>
        [...SettingsQueryKeys.all, 'on-date', date] as const,
};
